import { render, staticRenderFns } from "./setCamera.vue?vue&type=template&id=4998549a&scoped=true"
import script from "./setCamera.vue?vue&type=script&lang=js"
export * from "./setCamera.vue?vue&type=script&lang=js"
import style0 from "./setCamera.vue?vue&type=style&index=0&id=4998549a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4998549a",
  null
  
)

export default component.exports